import { Button, Icon, Tooltip } from '@wyz/ui';
import { useTheme } from '~/common/context';
import { usePersistedState } from '@wyz/utils';
import { PERMANENT_LS_KEYS } from '~/purchase/helpers';
import { useEffect, useEffectEvent } from 'react';

const ToggleButton = () => {
  const { isNavbarVerticalCollapsed, setConfig } = useTheme();

  const [isCollapsed, setIsCollapsed] = usePersistedState<boolean>(
    PERMANENT_LS_KEYS.NAVBAR_COLLAPSED_LS_KEY,
    true,
  );

  const updateNavbarState = useEffectEvent((isCollapsed: boolean) => {
    document.documentElement.classList.toggle(
      'navbar-vertical-collapsed',
      isCollapsed,
    );
    setConfig('isNavbarVerticalCollapsed', isCollapsed);
  });

  useEffect(() => {
    if (isCollapsed !== isNavbarVerticalCollapsed) {
      updateNavbarState(isCollapsed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCollapsed]);

  const handleClick = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    document.documentElement.classList.toggle(
      'navbar-vertical-collapsed',
      newState,
    );
    setConfig('isNavbarVerticalCollapsed', newState);
  };

  return (
    <Tooltip label='Toggle Navigation'>
      <div className='toggle-icon-wrapper d-none d-xl-inline'>
        <Button id='toggle-menu' variant='link' onClick={handleClick}>
          <Icon
            icon={isNavbarVerticalCollapsed ? 'closed-burger' : 'opened-burger'}
          />
        </Button>
      </div>
    </Tooltip>
  );
};

export default ToggleButton;
